import { useSetState } from '@domain-group/react-hooks'
import {
  Button, SidebarModal,
} from '@domain-group/suit-theme'
import useDataStoreItems from '@hooks/useDataStoreItems'

import PortalDataInput from '@sections/Client/packs/Campaign/screens/PortalData/components/PortalDataInput'
import { useEffect } from 'react'

const MODAL_KEY = 'ManagePortalDataDetailedFeaturesModal'

const defaultState = {
  hasEdited: false,
}

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManagePortalDataDetailedFeaturesModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const { creating } = useDataStoreItems({})

  const [state, setState] = useSetState(defaultState)
  const {
    hasEdited,
  } = state

  useEffect(() => {
    if (creating){
      setState({ hasEdited: true })
    }
  }, [creating])

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Detailed" titleSecondLine="Features" />

      <SidebarModal.Content>
        <PortalDataInput fieldKey="airConditioning" />

        <PortalDataInput marginTop="large" fieldKey="alarmSystem" />

        <PortalDataInput marginTop="large" fieldKey="balcony" />

        <PortalDataInput marginTop="large" fieldKey="broadband" />

        <PortalDataInput marginTop="large" fieldKey="builtInRobes" />

        <PortalDataInput marginTop="large" fieldKey="courtyard" />

        <PortalDataInput marginTop="large" fieldKey="deck" />

        <PortalDataInput marginTop="large" fieldKey="dishwasher" />

        <PortalDataInput marginTop="large" fieldKey="ductedCooling" />

        <PortalDataInput marginTop="large" fieldKey="ductedHeating" />

        <PortalDataInput marginTop="large" fieldKey="evaporativeCooling" />

        <PortalDataInput marginTop="large" fieldKey="floorboards" />

        <PortalDataInput marginTop="large" fieldKey="fullyFenced" />

        <PortalDataInput marginTop="large" fieldKey="gasHeating" />

        <PortalDataInput marginTop="large" fieldKey="gym" />

        <PortalDataInput marginTop="large" fieldKey="hotWaterService" />

        <PortalDataInput marginTop="large" fieldKey="hydronicHeating" />

        <PortalDataInput marginTop="large" fieldKey="insideSpa" />

        <PortalDataInput marginTop="large" fieldKey="intercom" />

        <PortalDataInput marginTop="large" fieldKey="openFirePlace" />

        <PortalDataInput marginTop="large" fieldKey="outdoorEnt" />

        <PortalDataInput marginTop="large" fieldKey="outsideSpa" />

        <PortalDataInput marginTop="large" fieldKey="payTV" />

        <PortalDataInput marginTop="large" fieldKey="poolAboveGround" />

        <PortalDataInput marginTop="large" fieldKey="poolInGround" />

        <PortalDataInput marginTop="large" fieldKey="remoteGarage" />

        <PortalDataInput marginTop="large" fieldKey="reverseCycleAircon" />

        <PortalDataInput marginTop="large" fieldKey="rumpusRoom" />

        <PortalDataInput marginTop="large" fieldKey="secureParking" />

        <PortalDataInput marginTop="large" fieldKey="shed" />

        <PortalDataInput marginTop="large" fieldKey="splitsystemAircon" />

        <PortalDataInput marginTop="large" fieldKey="splitsystemHeating" />

        <PortalDataInput marginTop="large" fieldKey="tennisCourt" />

        <PortalDataInput marginTop="large" fieldKey="vacuumSystem" />

        <PortalDataInput marginTop="large" fieldKey="workshop" />

        <PortalDataInput marginTop="large" fieldKey="otherFeatures" style={{ resize: 'vertical', height: 120 }} />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          loading={creating}
          onClick={() => closeModal()}
          size="large"
        >
          {hasEdited ? 'Close Modal (Changes Saved)' : 'Close Modal'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManagePortalDataDetailedFeaturesModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
